module.exports = __webpack_public_path__ + "img/list_jd_20.949d3a6f.jpg";